// URLs importantes
export const CONTACT_WHATSAPP = "https://wa.me/5521968940005";
export const INSTAGRAM_URL = "https://instagram.com/sejaradial";

// Informações de contato
export const CONTACT_EMAIL = "contato@sejaradial.com.br";
export const CONTACT_PHONE = "(21) 96894-0005";
export const CONTACT_ADDRESS = "Rio de Janeiro - RJ";

// Valores para calculadora
export const LIGHT_TARIFF = 0.85; // Tarifa média de energia em R$/kWh
export const SOLAR_EFFICIENCY = 0.92; // Eficiência média dos painéis

// URLs de ação (CTA)
export const FORM_URL = "/analise-gratuita";

// Outros
export const COMPANY_NAME = "Radial Energia";
export const COMPANY_TAGLINE =
  "Reduza sua conta de luz em até 95% com energia solar!";
export const COMPANY_DESCRIPTION =
  "Moradores do RJ já estão economizando centenas por mês com a Radial Energia Solar!";

// URL do Calendly
export const CALENDLY_URL = "https://calendly.com/seu-usuario";
